import { z } from "zod";

import { SubmitPredictionFeedbackPayload } from "#modules/feedback/view/useSubmitPredictionFeedback";
import { euroToCents } from "#shared/helpers/prices";
import { PredictionFeedbackCauseSchema } from "shared";

const toCents = (euros?: number) => (typeof euros === "number" ? euroToCents(euros) : undefined);

export const PredictionNegativeFeedbackFormSchema = z
  .object({
    causes: z.array(PredictionFeedbackCauseSchema).min(1),
    comment: z.string().optional(),
    actualMaterialPrice: z.number().optional(),
    actualAddedValuePrice: z.number().optional(),
    actualTotalPrice: z.number().optional(),
  })
  .transform(
    (values): SubmitPredictionFeedbackPayload => ({
      rating: -1,
      comment: values.comment || undefined,
      causes: values.causes,
      actualMaterialPrice: toCents(values.actualMaterialPrice),
      actualAddedValuePrice: toCents(values.actualAddedValuePrice),
      actualTotalPrice: toCents(values.actualTotalPrice),
    }),
  );

export type PredictionNegativeFeedbackFormValues = z.input<
  typeof PredictionNegativeFeedbackFormSchema
>;
